<template>
  <b-form-group :label="properties.label">
    <div class="d-flex align-items-center">
      <div class="border rounded value-container w-100 mr-2">{{showIfText}}</div>
      <i @click="showEditor" class="fas fa-edit text-primary hover-pointer"></i>
    </div>
    <b-modal
      centered
      no-close-on-backdrop
      title="Component rules"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="saveCondition"
      v-model="showingEditor"
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Close
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <div>
        <div v-for="(statement, statementIndex) in conditionStatements"  :key="statementIndex">
          <div class="d-flex align-items-center">
            <b-form-select v-model="statement.componentId" :options="componentOptions" size="sm" style="min-width: 200px; max-width: 200px;"></b-form-select>
            <div class="mx-3">=</div>

            <div v-if="statement.componentId" class="w-100">
              <b-form-input v-if="getValueToCompareData(statement.componentId).type == 'textInput'" v-model="statement.valueToCompare" size="sm"></b-form-input>
              <b-form-select v-if="getValueToCompareData(statement.componentId).type == 'dropdown'" v-model="statement.valueToCompare" :options="getValueToCompareData(statement.componentId).options" size="sm"></b-form-select>
            </div>
            
            <i class="fas fa-trash-alt ml-3 text-danger hover-pointer" @click="removeStatement(statementIndex)"></i>
            <i class="fas fa-plus ml-3 text-primary hover-pointer" @click="addStatement(statementIndex)"></i>
          </div>
          <div v-if="statement.nextStatementJoin" class="my-3">
            <b-form-select v-model="statement.nextStatementJoin" :options="statementJoinOptions" size="sm" style="width: 80px"></b-form-select>
          </div>
        </div>
        <i v-if="conditionStatements.length == 0" class="fas fa-plus ml-3 text-primary hover-pointer" @click="addStatement(0)"></i>
      </div>
    </b-modal>
  </b-form-group>
</template>

<script>
import { getFormBuilderComponents } from "../../../helpers/formBuilder"
import { mapState } from "vuex"
var esprima = require('esprima');
import collectionServer from "../../../server/collection";

export default {
  name: "ConditionEditorPropertyType",
  props: ["properties", "property", "value", "element", "formId"],
  data() {
    return {
      showingEditor: false,
      conditionStatements: [],
      components: [],
      computedComponentOptions: {}
    }
  },
  methods: {
    async showEditor() {
      let conditionStatements = this.valueToConditionStatements();
      this.conditionStatements = conditionStatements
      this.fetchFormBuilderComponents();
      await this.computeComponentOptions();
      this.showingEditor = true;
    },
    async computeComponentOptions() {
      let computedComponentOptions= {};
      for (let index = 0; index < this.components.length; index++) {
        const component = this.components[index];
        if(component.id.startsWith("Dropdown") || component.id.startsWith("SingleChoice") || component.id.startsWith("MultipleChoice")) {
          computedComponentOptions[component.id] = await this.getOptions(component.properties.options);
        }
      }
      this.computedComponentOptions = computedComponentOptions;
    },
    saveCondition() {
      let propertyValue = "{{("
      for (let index = 0; index < this.conditionStatements.length; index++) {
        const statement = this.conditionStatements[index];
        propertyValue += `${this.getValueToCompareData(statement.componentId, statement.valueToCompare).componentValue}==${this.getValueToCompareData(statement.componentId, statement.valueToCompare).valueToCompare}`
        if(statement.nextStatementJoin) {
          propertyValue += statement.nextStatementJoin;
        }
      }
      if(this.conditionStatements.length == 0) {
        propertyValue += "true"
      }
      propertyValue += ")}}"
      this.propertyValue = propertyValue;
    },
    removeStatement(statementIndex) {
      let newConditionStatements = [...this.conditionStatements]
      newConditionStatements.splice(statementIndex,1);
      if(newConditionStatements.length == statementIndex && newConditionStatements.length > 0) {
        newConditionStatements[statementIndex - 1].nextStatementJoin = null
      }
      this.conditionStatements = newConditionStatements;
    },
    addStatement(statementIndex) {
      let newConditionStatements = [...this.conditionStatements]
      let newStatement = {
        componentId: null,
        valueToCompare: "",
        nextStatementJoin: this.conditionStatements.length > 0 ? newConditionStatements[statementIndex].nextStatementJoin : null
      };
      if(this.conditionStatements.length > 0) {
        newConditionStatements[statementIndex].nextStatementJoin = "&&";
      }      
      
      if(statementIndex + 1 == newConditionStatements.length) {
        newConditionStatements.push(newStatement)
      }
      else {
        newConditionStatements.splice(statementIndex + 1, 0, newStatement)
      }
      
      this.conditionStatements = newConditionStatements;
    },
    fetchFormBuilderComponents() {
      let components = getFormBuilderComponents(this.currentForm.json)
      this.components = components;
    },
    getComponentFromId(componentId) {
      return this.components.find(c => c.id == componentId);
    },
    getValueToCompareData(componentId, valueToCompare = "") {
      if(
        componentId.startsWith("Dropdown")
      ) {
        return {
          type: "dropdown",
          options: this.computedComponentOptions[componentId].map(option => ({
            value: option,
            text: option
          })),
          componentValue: `components.${componentId}.Value.value`,
          valueToCompare: `'${valueToCompare}'`
        }
      }
      if(
        componentId.startsWith("SingleChoice")
      ) {
        return {
          type: "dropdown",
          options: this.computedComponentOptions[componentId].map(option => ({
            value: option,
            text: option
          })),
          componentValue: `components.${componentId}.Value`,
          valueToCompare: `'${valueToCompare}'`
        }
      }
      if(
        componentId.startsWith("MultipleChoice")
      ) {
        return {
          type: "dropdown",
          options: this.computedComponentOptions[componentId].map(option => ({
            value: option,
            text: option
          })),
          componentValue: `components.${componentId}.Value.find(item => item == '${valueToCompare}')`,
          valueToCompare: `'${valueToCompare}'`
        }
      }
      if(
        componentId.startsWith("Boolean")
      ) {
        return {
          type: "dropdown",
          options: [
            {
              value: true,
              text: "True"
            },
            {
              value: false,
              text: "False"
            }
          ],
          componentValue: `components.${componentId}.Value`,
          valueToCompare: valueToCompare
        }
      }
      return {
        type: "textInput",
        componentValue: `components.${componentId}.Value`,
        valueToCompare: `'${valueToCompare}'`
      }
    },
    valueToConditionStatements() {
      let conditionStatements = [];
      try {
        let code = this.propertyValue.substr(2,this.propertyValue.length - 4)
        let tokens = esprima.tokenize(code)
        for (let index = 0; index < tokens.length; index++) {
          const token = tokens[index];
          if(token.type == "Identifier" && token.value == 'components') {
            let componentId = tokens[index + 2].value
            let valueToCompareToken = null;
            for (let index2 = index + 3; index2 < tokens.length; index2++) {
              const token2 = tokens[index2];
              if(token2.value == '==') {
                valueToCompareToken = tokens[index2 + 1]
                break;
              }
            }
            let valueToCompare = valueToCompareToken.value
            if(valueToCompareToken.type == "String") {
              valueToCompare = valueToCompare.substr(1, valueToCompare.length - 2)
            }
            
            conditionStatements.push(
              {
                componentId: componentId,
                valueToCompare: valueToCompare,
                nextStatementJoin: null
              } 
            )
            index += 6;
          }
          else if(token.type == "Punctuator" && (token.value == '&&' || token.value == '||')) {
            conditionStatements[conditionStatements.length - 1].nextStatementJoin = token.value
          }
        }  
      } catch (error) {
        console.log(error)
      }
      if(conditionStatements.length == 0) {
        conditionStatements.push({
          componentId: null,
          valueToCompare: "",
          nextStatementJoin: null
        });
      } 
      return conditionStatements
    },
    async getOptions(options) {
      if (typeof options == "string") {
        let re = /\{\{collections.(?:(?!\}\}).)*\}\}/g;
        const matches = [...options.matchAll(re)];
        if (
          matches.length == 1 &&
          options.startsWith("{{") &&
          options.endsWith("}}")
        ) {
          const collections = await collectionServer.query();
          const collection = collections.find(
            c =>
              c.name ==
              options.slice(
                14,
                options.length - 2
              )
          );
          return collection.data.items;
        } else return options;
      } else return options;
    },
  },
  computed: {
    ...mapState("formBuilder", {
      forms: state => state.form
    }),
    currentForm() {
      return this.forms[this.formId]
    },
    propertyValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        let newPropertyValue = newValue;
        if(this.properties.updateValueMiddleware) {
          newPropertyValue = this.properties.updateValueMiddleware(newPropertyValue);
        }
        this.$emit("update-value", this.property, newPropertyValue);
      }
    },
    showIfText() {
      let conditionText = ""
      try {
        let code = this.propertyValue.substr(2,this.propertyValue.length - 4)
        let tokens = esprima.tokenize(code)
        for (let index = 0; index < tokens.length; index++) {
          const token = tokens[index];
          if(token.type == "Identifier" && token.value == 'components') {
            let componentId = tokens[index + 2].value
            let valueToCompare = '';
            for (let index2 = index + 3; index2 < tokens.length; index2++) {
              const token2 = tokens[index2];
              if(token2.value == '==') {
                valueToCompare = tokens[index2 + 1].value
                break;
              }
            }
            conditionText += `${componentId} = ${valueToCompare}`
            index += 6;
          }
          else if(token.type == "Punctuator" && (token.value == '&&' || token.value == '||')) {
            conditionText += ` ${token.value == '&&' ? 'and' : 'or'} `
          }
        }
      } catch (error) {
        console.log(error)
        conditionText = "";
      }
      return conditionText ? `Show if ${conditionText}` : "No condition"
    },
    componentOptions() {
      return this.components.filter(c => 
          c.id.startsWith("TextInput") ||
          c.id.startsWith("Boolean") ||
          c.id.startsWith("EmailInput") ||
          c.id.startsWith("PhoneInput") ||
          c.id.startsWith("NumberInput") ||
          c.id.startsWith("PasswordInput") ||
          c.id.startsWith("Dropdown") ||
          c.id.startsWith("DatePicker") ||
          c.id.startsWith("TimePicker") ||
          c.id.startsWith("Textarea") ||
          c.id.startsWith("SingleChoice") ||
          c.id.startsWith("MultipleChoice")
        ).map(c => ({
        value: c.id,
        text: c.id
      }))
    },
    statementJoinOptions() {
      return [
        {
          value: "&&",
          text: "And"
        },
        {
          value: "||",
          text: "Or"
        }
      ]
    },
  }
};
</script>

<style>
.lower-font-size {
  font-size: 14px !important;
}
.lower-font-size .custom-control-label {
  padding-top: 2px;
}
.value-container {
  height: 31px;
  font-size: 14px; 
  padding-top: 3px; 
  padding-left: 6px; 
  padding-right: 6px; 
  white-space: nowrap; 
  overflow-x: hidden;
  text-overflow: ellipsis;
}
</style>
